import React, { useEffect, useState } from 'react';
import api from '../services/api';
import {
  Card, CardBody, CardTitle, ListGroup, ListGroupItem, Spinner
} from 'reactstrap';

const MonthlyTransactionByAction = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/transactions/monthly-by-action/')
      .then(response => {
        setSummary(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching transaction summary by action:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Spinner color="primary" />;
  }

  return (
    <Card className="mb-3">
      <CardBody>
        <CardTitle tag="h5" className="text-center">Transaction Types</CardTitle>
        <ListGroup>
          {summary.actions.map((item, index) => (
            <ListGroupItem key={index}>
              {item.count} - <strong>{item.action}</strong> 
            </ListGroupItem>
          ))}
        </ListGroup>
      </CardBody>
    </Card>
  );
};

export default MonthlyTransactionByAction;
